import { render, staticRenderFns } from "./tab-memo.vue?vue&type=template&id=406c6202"
import script from "./tab-memo.vue?vue&type=script&lang=js"
export * from "./tab-memo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports